import { Pipe, PipeTransform } from "@angular/core";
import { SeparateurMillier } from './SeparateurMillier';

@Pipe({
  name:'pipeRubrique'
})
export class RubriquePipeService  implements PipeTransform {

  // transform(value: SeparateurMillier):string {
  //   if (value==null) return null
  //  return this.separateurMil(value)
  // }
  transform(value: string):string {
    let type
    switch (value) {
      case 'Auto':
        type="AUTOMOBILE"
        break;
        case 'Sante':
          type="SANTE"
          break;
          case 'Individuelle':
        type="INDIVIDUELLE ACCIDENTS"
        break;
        case 'Voyage':
        type="VOYAGE"
        break;
        case 'Mrh':
        type="MULTIRISQUE HABITATIONS"
        break
     
    }
 
   return type
  }
  
  
}